var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inputFields" },
    [
      _vm.is_per_warehouse
        ? _c("sc-warehouses-list", {
            ref: "warehouseListComponent",
            attrs: { hasConfiguration: false }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.formFields
        ? _c(
            "div",
            { staticClass: "mainContent__inputs" },
            [
              _c(
                "div",
                { staticClass: "mainContent__validatedFields" },
                [
                  _vm._l(_vm.validatedFields, function(field) {
                    return _c(
                      "div",
                      { key: field.name, staticClass: "mainContent__input" },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "sc-tooltip",
                              {
                                attrs: {
                                  type: "is-light",
                                  position: "is-right",
                                  label: field.tooltip
                                }
                              },
                              [
                                _c("sc-icon", {
                                  attrs: {
                                    size: "is-small",
                                    icon: "info-circle"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("label", { attrs: { for: field.name } }, [
                              _c("strong", [_vm._v(_vm._s(field.title))])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-field",
                          {
                            attrs: {
                              message:
                                field.required &&
                                !_vm.formFields[field.name] &&
                                _vm.alreadyChecked
                                  ? "O campo é obrigatório."
                                  : "",
                              type:
                                field.required &&
                                !_vm.formFields[field.name] &&
                                _vm.alreadyChecked
                                  ? "is-danger"
                                  : ""
                            }
                          },
                          [
                            _c("sc-input", {
                              attrs: {
                                type: field.type,
                                disabled: _vm.formFields.validated
                              },
                              model: {
                                value: _vm.formFields[field.name],
                                callback: function($$v) {
                                  _vm.$set(_vm.formFields, field.name, $$v)
                                },
                                expression: "formFields[field.name]"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c("sc-button", {
                    attrs: {
                      text: "Validar",
                      theme: "primary",
                      disabled: _vm.formFields.validated
                    },
                    on: {
                      click: function($event) {
                        _vm.onClickValidate()
                      }
                    }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm._l(_vm.conditionalFields, function(field) {
                return _c(
                  "div",
                  { key: field.name, staticClass: "mainContent__input" },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "sc-tooltip",
                          {
                            attrs: {
                              type: "is-light",
                              position: "is-right",
                              label: field.tooltip
                            }
                          },
                          [
                            _c("sc-icon", {
                              attrs: { size: "is-small", icon: "info-circle" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("label", { attrs: { for: field.name } }, [
                          _c("strong", [_vm._v(_vm._s(field.title))])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-field",
                      {
                        attrs: {
                          message:
                            field.required &&
                            !_vm.formFields[field.name] &&
                            _vm.alreadyChecked
                              ? "O campo é obrigatório."
                              : "",
                          type:
                            field.required &&
                            !_vm.formFields[field.name] &&
                            _vm.alreadyChecked
                              ? "is-danger"
                              : ""
                        }
                      },
                      [
                        _c("sc-input", {
                          attrs: {
                            type: field.type,
                            disabled: !_vm.formFields.validated
                          },
                          model: {
                            value: _vm.formFields[field.name],
                            callback: function($$v) {
                              _vm.$set(_vm.formFields, field.name, $$v)
                            },
                            expression: "formFields[field.name]"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e76d633", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e76d633","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/input-fields/InputFields.vue
// module id = null
// module chunks = 